import React, { Component } from 'react'
import Slide from 'react-reveal/Slide';
import ModalAbout from '../content-section-02/modal-about'
import ModalPersyaratan from '../content-section-02/modal-persyaratan'


export class ContentSection02 extends Component {
    render() {
        return (
            <section className="content-section-02" id="about">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 offset-xl-1 col-sm-6 col-10 order-sm-2">
                            <div className="content-img">
                                <Slide right>
                                    <img src={require("../../assets/image/PP-HERO-EPC.png")}  alt=''/>
                                </Slide>
                            </div>
                        </div>
                        <div className="col-xl-5  col-sm-6 order-sm-1">
                            <div className="content-left-content">
                                <h2>About</h2>
                                <p>
                                    Di tahun 2019, untuk pertama kalinya PT PP (Persero) Tbk menyelenggarakan event Hackathon dengan tema Digital Construction Hack.
                                    Hackathon ini merupakan rangkaian acara perayaan ulang tahun PT PP yang ke 66. 
                                    {/* Melalui event Hackathon ini, PT PP (Persero) Tbk ingin memulai gerakan kesadaran digitalisasi. Hal ini disebabkan adopsi digital pada sektor konstruksi jauh lebih lambat dibandingkan dengan sektor lainnya. Sebagai sendi dan cara kerja baru dunia konstruksi di Indonesia, event ini diharapkan untuk menyelesaikan permasalahan yang dihadapi di dunia konstruksi khususnya PT PP dengan cara digitalisasi.
                                    PT PP (Persero) Tbk mengundang seluruh developer TI, startup, pelajar dan professional di Indonesia untuk berpatisipasi di Digital Construction Hack 2019 TANPA DIPUNGUT BIAYA APAPUN.
                                    Saatnya bereksplorasi dan berikan solusi inovatif yang mampu menjawab tantangan yang dihadapi bidang konstruksi. */}
                                </p>
                                <div className="btn-toolbar text-center">
                                    <ModalAbout />
                                    <ModalPersyaratan/>
                                </div>
                                {/* <ul className="content-list-business">
                                    <li><a href="http://www.ptpp.co.id/our-business/business-line/construction" target="_blank" rel="noopener noreferrer">Construction</a></li>
                                    <li><a href="http://www.ptpp.co.id/our-business/business-line/property" target="_blank" rel="noopener noreferrer">Property</a></li>
                                    <li><a href="http://www.ptpp.co.id/our-business/business-line/epc" target="_blank" rel="noopener noreferrer">EPC</a></li>
                                    <li><a href="http://www.ptpp.co.id/our-business/business-line/urban" target="_blank" rel="noopener noreferrer">Urban</a></li>
                                    <li><a href="http://www.ptpp.co.id/our-business/business-line/presisi" target="_blank" rel="noopener noreferrer">Presisi</a></li>
                                    <li><a href="http://www.ptpp.co.id/our-business/business-line/investment" target="_blank" rel="noopener noreferrer">Investment</a></li>
                                </ul> */}
                                
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
        )
    }
}

export default ContentSection02
